import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import HomePage from "./HomePage";
import About from "./about";
import Services from "./services";
import SchoolSolutions from "./schoolSolutions";
import PMESolutions from "./pmeSolutions";
import Portfolio from "./portfolio";
import Contact from "./contact";
import "./FullpageWrapper.css";

function FullpageWrapper() {
  return (
    <div className="onepage-layout">
      <Header onePage />

      <main className="onepage-main">
        <section id="accueil" className="onepage-section">
          <HomePage embedded />
        </section>

        <section id="a-propos" className="onepage-section">
          <About embedded />
        </section>

        <section id="solutions" className="onepage-section">
          <Services embedded />
        </section>

        <section id="solutions-ecoles" className="onepage-section">
          <SchoolSolutions embedded />
        </section>

        <section id="solutions-pme" className="onepage-section">
          <PMESolutions embedded />
        </section>

        <section id="nos-realisations" className="onepage-section">
          <Portfolio embedded />
        </section>

        <section id="contact" className="onepage-section">
          <Contact embedded />
        </section>
      </main>

      <Footer onePage />
    </div>
  );
}

export default FullpageWrapper;
